import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
interface Idps {
  [key: string]: {
    title: string;
  };
}

interface PlatformSelectorProps {
  idps: Idps;
  disabled: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Platform-Selector',
  props: {
  idps: null,
  disabled: { type: Boolean },
  value: null
},
  emits: ["input"],
  setup(__props) {

const props = __props;




const { value: selectedIdp } = __MACROS_useVModel(["value", undefined, "input"]);

const idpsIndex = _computed(() => Object.keys(props.idps).indexOf(selectedIdp.value));

const change = (value: number) => {
  const selectedIdpValue = Object.keys(props.idps)[value];
  selectedIdp.value = selectedIdpValue;
};

return { __sfc: true,props, selectedIdp, idpsIndex, change, _computed, __MACROS_useVModel }
}

})